import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';

// Define a class that implements IContextMewnuData.
export abstract class ContextMenuItemBase implements IContextMenuItem {
    // Private properties.
    protected readonly itemTitle: string;
    protected readonly submenus: IContextMenuItem[] = null;
    protected contextItem: any;

    // Implement IContextMenuItem.
    public get menuItemTitle(): string {
        return this.itemTitle;
    }

    public get DisplayMenuItem(): boolean {
        return true; // A reasonable default.
    }

    public get MenuItemDisabled(): boolean {
        // Note:  this default method implementation simply returns
        //        false, which is sufficiente for some menu items.
        return false;
    }

    public get HasSubmenus(): boolean {
        return ((this.submenus != null) && (this.submenus.length > 0));
    }
    public get Submenus(): IContextMenuItem[] {
        return this.submenus;
    }

    get IsMenuDivider(): boolean {
        return false; // A reasonable default.
    }

    public abstract menuItemSelected(contextItem: any, eventData: any): void;

    public set ContextItem(value: any) {
        this.contextItem = value;
    }

    // Constructor.
    public constructor(itemTitle: string, submenus: IContextMenuItem[] = null) {
        this.itemTitle = itemTitle;
        if (submenus != null)
            this.submenus = submenus;
    }
}

export class ContextMenuItemDivider extends ContextMenuItemBase {
    public constructor() {
        super(null, null);
    }

    public get IsMenuDivider(): boolean {
        return true;
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        // Note:  this method is a NOOP by design.
    }
}

export abstract class ContextItemAndOneParamContextMenuBase extends ContextMenuItemBase {
    public constructor(itemTitle: string, private targetComponent: any, private menuItemSelectedTargetMethodName: string, private targetMethodParam, submenus: IContextMenuItem[]) {
        super(itemTitle, submenus);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.targetComponent[this.menuItemSelectedTargetMethodName](contextItem, this.targetMethodParam);
    }
}
